import { useEffect, useRef, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Star, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

const TrustIndexWidget = ({ widgetId }) => {
  const containerRef = useRef(null);
  const scriptRef = useRef(null);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    if (containerRef.current && !scriptRef.current) {
      const script = document.createElement('script');
      script.defer = true;
      script.async = true;
      script.src = `https://cdn.trustindex.io/loader.js?${widgetId}`;
      script.onload = () => {
        setHasLoaded(true);
        // Check if widget rendered after a delay
        setTimeout(() => {
          const widgetContent = containerRef.current?.querySelector('.ti-widget');
          if (!widgetContent) {
            setShowFallback(true);
          }
        }, 3000);
      };
      script.onerror = () => setShowFallback(true);
      containerRef.current.appendChild(script);
      scriptRef.current = script;
    }

    return () => {
      // Don't remove script on cleanup
    };
  }, [widgetId]);

  return (
    <div ref={containerRef} className="trustindex min-h-[100px]">
      {showFallback && (
        <Card className="border-none shadow-lg">
          <CardContent className="p-8 text-center">
            <div className="flex items-center justify-center gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-6 w-6 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <p className="text-2xl font-bold mb-2">5.0 Rating on Google</p>
            <p className="text-muted-foreground mb-6">
              See what our customers are saying about Comal Glass Company
            </p>
            <Button asChild>
              <a 
                href="https://www.google.com/search?q=comal+glass+company+reviews" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2"
              >
                <span>View Reviews on Google</span>
                <ExternalLink className="h-4 w-4" />
              </a>
            </Button>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export const GoogleReviews = () => {
  return (
    <div className="w-full">
      <div className="text-center mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4">
          What Our <span className="text-gradient-cyan">Customers Say</span>
        </h2>
        <p className="text-lg text-muted-foreground mb-6">
          Read reviews from our satisfied customers on Google
        </p>
      </div>

      {/* TrustIndex Google Reviews Widget */}
      <div className="max-w-6xl mx-auto mb-8" data-testid="trustindex-widget-container">
        <TrustIndexWidget widgetId="e642bb2618683442c58660be6f3" />
      </div>
    </div>
  );
};

export default GoogleReviews;
